<template>
  <v-app>
    <v-toolbar flat dark class="BackgroundStyle-2">

      <v-toolbar-title>MyWalletWatcher</v-toolbar-title>

    </v-toolbar>
    <v-content>
      <v-container fluid fill-height class="BackgroundStyle-2">
        <v-layout align-center justify-center>
          <v-flex xs12 sm9 md6>
            <div class="Logo1" width="100%">
              <img src="../../assets/Mww128.png" alt="My Wallet Watcher" align-center>
            </div>
            <v-card class="elevation-3">

              <v-stepper v-model="stepper" vertical>
                <v-stepper-step step="1" icon="fa fa-user-wo" :complete="stepper > 1">Personal Details</v-stepper-step>
                <v-stepper-content step="1">
                  <v-card class="mb-5" height="350px">
                    <div>
                      <v-text-field label="UserName"
                                    v-model="user.userName"
                                    :error-messages="userNameErrors"
                                    @input="$v.user.userName.$touch()"
                                    @blur="$v.user.userName.$touch()"></v-text-field>
                    </div>
                    <div>
                      <v-text-field label="Email"
                                    v-model="user.email"
                                    :error-messages="emailErrors"
                                    @input="$v.user.email.$touch()"
                                    @blur="$v.user.email.$touch()"></v-text-field>
                    </div>
                    <div>
                      <v-autocomplete :items="countries"
                                      v-model="user.countryName"
                                      label="Country"
                                      :error-messages="countryNameErrors"
                                      @input="$v.user.countryName.$touch()"
                                      @blur="$v.user.countryName.$touch()"></v-autocomplete>

                    </div>
                    <div>
                      <v-text-field label="GCT" type="number" v-model="user.gctPercentage"
                                    :error-messages="gctPercentageErrors"
                                    @input="$v.user.gctPercentage.$touch()"
                                    @blur="$v.user.gctPercentage.$touch()"></v-text-field>
                    </div>
                    <v-checkbox label="Join Newsletter" v-model="user.newsletter"></v-checkbox>
                  </v-card>

                  <v-btn color="primary" class="right" round @click.native="moveToSecondStep($v.user)">Continue</v-btn>
                </v-stepper-content>
                <!--<v-stepper-step step="2" icon="fa fa-rss" :complete="stepper > 2">Subscription</v-stepper-step>-->
                <!--<v-stepper-content step="2">
              <v-card class="mb-5" height="350px">
                <v-alert type="error" dismissible :value="true" v-model="showErrorMessage">
                  {{errorMessage}}
                </v-alert>
                <v-data-iterator content-tag="v-layout"
                                 row
                                 wrap
                                 :items="subscriptionTypes"
                                 :hide-actions="true">
                  <v-flex slot="item"
                          slot-scope="props"
                          xs12
                          sm4
                          md4
                          lg3 >
                    <div v-on:click="subscriptionSelected(props.item.name)">
                      <v-card color="#4caf50" >
                        <v-card-title><div style="width: 100%"><h4 style="float: left;">{{ props.item.name }}</h4> <h5 style="float: right;">Price: ${{ props.item.price }}</h5></div></v-card-title>
                        <v-divider></v-divider>
                        <v-list dense>
                          <v-list-tile>
                            v-list-tile-content>Price:</v-list-tile-content>
      <v-list-tile-content class="align-end">{{ props.item.price }}</v-list-tile-content>
                          </v-list-tile>

                        </v-list>
                      </v-card>
                    </div>
                  </v-flex>

                </v-data-iterator>
              </v-card>
              <v-btn color="primary" round @click.native="stepper = 1">Back</v-btn>
              <v-btn color="primary" round class="right" @click.native="moveToFinalStep()">Continue</v-btn>

            </v-stepper-content>-->
                <v-stepper-step step="2" icon="fa fa-unlock" :complete="stepper > 2">Password</v-stepper-step>
                <v-stepper-content step="2">
                  <v-card class="mb-5" height="350px">
                    <div>
                      <v-text-field v-model="user.password"
                                    label="Password"
                                    :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                                    :type="passwordShow ? 'text' : 'password'"
                                    :rules="[rules.strength]"
                                    :error-messages="passwordErrors"
                                    @input="$v.user.password.$touch()"
                                    @blur="$v.user.password.$touch()"
                                    @click:append="passwordShow = !passwordShow"></v-text-field>
                      <br />
                      <v-text-field v-model="user.cpassword"
                                    label="Confirm Password"
                                    :append-icon="cpasswordShow ? 'visibility_off' : 'visibility'"
                                    :type="cpasswordShow ? 'text' : 'password'"
                                    :error-messages="cPasswordErrors"
                                    @input="$v.user.cpassword.$touch()"
                                    @blur="$v.user.cpassword.$touch()"
                                    @click:append="cpasswordShow = !cpasswordShow"></v-text-field>
                    </div>
                  </v-card>
                  <v-btn color="primary" round @click.native="stepper = 1 ">Back</v-btn>
                  <v-btn color="primary" round class="right" @click.native="onComplete($v.user)">Finish</v-btn>
                </v-stepper-content>
              </v-stepper>

            </v-card>
            <v-card-text>
              <v-divider light> </v-divider>
              <v-btn color="accent" block v-on:click.prevent="$router.push({ path: '/Login' })">
                Login
              </v-btn>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, sameAs, email } from 'vuelidate/lib/validators'

  import zxcvbn from 'zxcvbn'
  //import '../../javascript/zxcvbn.js'

  import { HTTP } from '../../api/httpCommon';

  export default {
    mixins: [validationMixin],
    /// Added vm to create a Component Instance that can be called later
    data( vm ) {
      return {
        showErrorMessage: false,
        errorMessage: '',
        passwordShow: false,
        cpasswordShow:false,
        stepper:'',
        user: {
          userName: '',
          email: '',
          password: '',
          cpassword: '',
          subscriptionType: 'Free',
          //PaymentDay: 1,
          gctPercentage: 0,
          //GCTDate: '',
          countryName: '',
          newsletter: false,
          //AddExtraToBudget: false,
          //ExtraPercentage: 0,
          addExcessToSavingsAccount: false
        },
        rules: {
          strength: vm.getPasswordStrength
        },
        countries: ["Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Ashmore and Cartier Islands", "Australia", "Austria", "Azerbaijan", "The Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Botswana", "Brazil", "British Virgin Islands", "Canada", "Cayman Islands", "Chile", "China", "Colombia", "Costa Rica", "Cuba", "Czech Republic", "Denmark", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
          "Finland", "France", "French Guiana", "Germany", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guatemala", "Guinea", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Ireland", "Italy", "Jamaica", "Japan", "Martinique", "Mexico", "Montserrat", "Netherlands", "Netherlands Antilles", "New Zealand", "Norway", "Panama", "Poland", "Portugal", "Puerto Rico", "Qatar", "Romania", "Russia", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Saudi Arabia", "Sweden", "Switzerland", "Trinidad and Tobago", "Turkey", "Turks and Caicos Islands", "United Kingdom", "United States", "Venezuela"],
        subscriptionTypes: [
          { name: "Free", price: 0 },
          { name: "Single", price: 1.00 },
          { name: "Couple", price: 1.30 }
        ],
        count: 0
      }
    },
    computed: {
      userNameErrors() {
        const errors = []
        if (!this.$v.user.userName.$dirty) return errors
        !this.$v.user.userName.required && errors.push('Username is required')
        return errors
      },
      emailErrors() {
        const errors = []
        if (!this.$v.user.email.$dirty) return errors
        !this.$v.user.email.email && errors.push('Must be valid e-mail')
        !this.$v.user.email.required && errors.push('E-mail is required')
        return errors
      },
      passwordErrors() {
        const errors = []
        if (!this.$v.user.password.$dirty) return errors
        !this.$v.user.password.required && errors.push('Password is required')
        return errors
      },
      cPasswordErrors() {
        const errors = []
        if (!this.$v.user.cpassword.$dirty) return errors
        !this.$v.user.cpassword.sameAsPassword && errors.push(' Passwords must be identical')
        !this.$v.user.cpassword.required && errors.push('Password is required')
        return errors
      },
      countryNameErrors() {
        const errors = []
        if (!this.$v.user.countryName.$dirty) return errors
        !this.$v.user.countryName.required && errors.push('Country is required')
        return errors
      },
      gctPercentageErrors() {
        const errors = []
        if (!this.$v.user.gctPercentage.$dirty) return errors
        !this.$v.user.gctPercentage.required && errors.push('GCT is required')
        return errors
      }
    },
    methods: {
      moveToSecondStep: function ($v) {
        if (this.validatePersonalDetail($v)) {
          this.stepper = 2
        }
      },
      moveToFinalStep: function () {
        if (this.validateSubscription()) {
          this.stepper = 3
        }
      },
      validateSubscription: function () {
        if (this.user.subscriptionType === '') {
          this.showErrorMessage = true
          this.errorMessage = "You Must Select A Subscription Type"
          return false
        }
        return true
      },
      validatePersonalDetail: function ($v) {
        //Triggers Error Messages
        $v.userName.$touch()
        $v.email.$touch()
        $v.countryName.$touch()
        $v.gctPercentage.$touch()

        if ($v.userName.$invalid || $v.email.$invalid || $v.countryName.$invalid || $v.gctPercentage.$invalid) {
          return false
        }
        return true

      },
      validatePassword: function ($v) {
        //Triggers Error Messages
        $v.password.$touch()
        $v.cpassword.$touch()

        if ($v.password.$invalid || $v.cpassword.$invalid) {
          return false
        }
        return true
      },
      register: function () {
        HTTP.post('Registration',
          this.user
        )
          .then(response => {

            if (response.status === 200) {
              this.$router.push({ path: '/login' })
            }

          })
          .catch(e => {
            console.log(e)
          })
      },
      subscriptionSelected: function (itemName) {
        this.user.subscriptionType = itemName;
        this.showErrorMessage = false
      },
      onComplete: function ($v) {
        if (this.validatePersonalDetail($v) && this.validateSubscription() && this.validatePassword($v)) {
          this.register()
        }
      },
      getPasswordStrength: function () {
        if (this.user.password !== '' && this.user.password !== null && this.user.password !== undefined) {
          let result = zxcvbn(this.user.password)

          switch (result.score) {
            case 0:
              return 'Very Weak Password';
            
            case 1:
              return 'Weak Password';
              
            case 2:
              return 'Somewhat Weak Password';
          }
        }
        return true
      }
    },
    validations: {
      user: {
        userName: {
          required
        },
        email: {
          required,
          email
        },
        password: {
          required
        },
        cpassword: {
          required,
          sameAsPassword: sameAs('password')
        },
        countryName: {
          required
        },
        gctPercentage: {
          required
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/userAccount/Registration.vue